import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/public/homePage/certification/ISO2052.png");
;
import(/* webpackMode: "eager" */ "/app/public/homePage/certification/ISOCertified.png");
;
import(/* webpackMode: "eager" */ "/app/public/homePage/icons/advertising.svg");
;
import(/* webpackMode: "eager" */ "/app/public/homePage/icons/consumer_goods_icon.svg");
;
import(/* webpackMode: "eager" */ "/app/public/homePage/icons/down_mouse.svg");
;
import(/* webpackMode: "eager" */ "/app/public/homePage/icons/entertainment.svg");
;
import(/* webpackMode: "eager" */ "/app/public/homePage/icons/financial_services.svg");
;
import(/* webpackMode: "eager" */ "/app/public/homePage/icons/foods_beverage_icon.svg");
;
import(/* webpackMode: "eager" */ "/app/public/homePage/icons/healthcare.svg");
;
import(/* webpackMode: "eager" */ "/app/public/homePage/icons/right_arrow.svg");
;
import(/* webpackMode: "eager" */ "/app/public/homePage/icons/sports.svg");
;
import(/* webpackMode: "eager" */ "/app/public/homePage/icons/technology.svg");
;
import(/* webpackMode: "eager" */ "/app/public/homePage/research/advanced.svg");
;
import(/* webpackMode: "eager" */ "/app/public/homePage/research/brand.svg");
;
import(/* webpackMode: "eager" */ "/app/public/homePage/research/consumer_icon.svg");
;
import(/* webpackMode: "eager" */ "/app/public/homePage/research/market.svg");
;
import(/* webpackMode: "eager" */ "/app/public/homePage/research/mystery.svg");
;
import(/* webpackMode: "eager" */ "/app/public/homePage/research/product_insigts.svg");
;
import(/* webpackMode: "eager" */ "/app/public/homePage/research/product.svg");
;
import(/* webpackMode: "eager" */ "/app/public/homePage/research/sensory.svg");
;
import(/* webpackMode: "eager" */ "/app/public/homePage/technology/ai.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/homePage/technology/data_validator.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/homePage/technology/engame.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/homePage/technology/inscribee.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/homePage/technology/raven.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/homePage/technology/slm_new.png");
;
import(/* webpackMode: "eager" */ "/app/public/homePage/technology/tabmegenhome.jpg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/Component/Footer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/Component/Footer/logoFoter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/Component/Header/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/Component/Testimonials/HomeSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/Component/Testimonials/index.tsx");
